<template>
<!-- Root element of PhotoSwipe. Must have class pswp. -->
<div class="pswp" tabindex="-1" role="dialog" aria-hidden="true">

    <!-- Background of PhotoSwipe.
         It's a separate element as animating opacity is faster than rgba(). -->
    <div class="pswp__bg"></div>

    <!-- Slides wrapper with overflow:hidden. -->
    <div class="pswp__scroll-wrap">

        <!-- Container that holds slides.
            PhotoSwipe keeps only 3 of them in the DOM to save memory.
            Don't modify these 3 pswp__item elements, data is added later on. -->
        <div class="pswp__container">
            <div class="pswp__item"></div>
            <div class="pswp__item"></div>
            <div class="pswp__item"></div>
        </div>

        <!-- Default (PhotoSwipeUI_Default) interface on top of sliding area. Can be changed. -->
        <div class="pswp__ui pswp__ui--hidden">

            <div class="pswp__top-bar">

                <!--  Controls are self-explanatory. Order can be changed. -->

                <div class="pswp__counter"></div>

                <button class="pswp__button pswp__button--close" title="Close (Esc)"></button>

                <button class="pswp__button pswp__button--share" title="Share"></button>

                <button class="pswp__button pswp__button--fs" title="Toggle fullscreen"></button>

                <button class="pswp__button pswp__button--zoom" title="Zoom in/out"></button>

                <!-- Preloader demo http://codepen.io/dimsemenov/pen/yyBWoR -->
                <!-- element will get class pswp__preloader--active when preloader is running -->
                <div class="pswp__preloader">
                    <div class="pswp__preloader__icn">
                        <div class="pswp__preloader__cut">
                            <div class="pswp__preloader__donut"></div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">
                <div class="pswp__share-tooltip"></div>
            </div>

            <button class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)">
            </button>

            <button class="pswp__button pswp__button--arrow--right" title="Next (arrow right)">
            </button>

            <div class="pswp__caption">
                <div class="pswp__caption__center"></div>
            </div>

        </div>

    </div>

</div>
</template>

<script>
import 'photoswipe/dist/photoswipe.css';
import 'photoswipe/dist/default-skin/default-skin.css';
import PhotoSwipe from 'photoswipe/dist/photoswipe';
import PhotoSwipeDefaultUI from 'photoswipe/dist/photoswipe-ui-default';

/**
 * Wrapper for PhotoSwipe
 * https://github.com/dimsemenov/PhotoSwipe
 */
export default {
    name: 'image-swipe',

    data: function () {
        return {
            photoswipe: null
        };
    },

    beforeDestroy: function () {
        try {
            this.photoswipe && this.photoswipe.destroy();
        }
        catch (error) {}
    },

    methods: {
        open: function (index, items, options) {
            const opts = _.extend({
                // Core options ------------------------------------
                // http://photoswipe.com/documentation/options.html
                closeOnScroll: false,
                closeOnVerticalDrag: false,
                index: index,


                // UI options --------------------------------------

                // Size of top & bottom bars in pixels,
                // "bottom" parameter can be 'auto' (will calculate height of caption)
                // option applies only when mouse is used,
                // or width of screen is more than 1200px
                //
                // (Also refer to `parseVerticalMargin` event)
                barsSize: {top: 44, bottom: 'auto'},

                // Adds class pswp__ui--idle to pswp__ui element when mouse isn't moving for 4000ms
                timeToIdle: 4000,

                // Same as above, but this timer applies when mouse leaves the window
                timeToIdleOutside: 1000,

                // Delay until loading indicator is displayed
                loadingIndicatorDelay: 1000,

                // Function builds caption markup
                addCaptionHTMLFn: function (item, captionEl, isFake) {
                    // item      - slide object
                    // captionEl - caption DOM element
                    // isFake    - true when content is added to fake caption container
                    //             (used to get size of next or previous caption)

                    // Set title from item (usually merge of Artwork Name, Makers and production years)
                    captionEl.children[0].innerHTML = (item && item.title) || '';
                    return true;
                },

                // Buttons/elements
                closeEl: true,
                captionEl: true,
                fullscreenEl: false,
                zoomEl: false,
                shareEl: false,
                counterEl: false, // FIXME: default counter does not work with pagination
                arrowEl: true,
                preloaderEl: true,

                // Tap on sliding area should close gallery
                tapToClose: false,
                pinchToClose: false,

                // Tap should toggle visibility of controls
                tapToToggleControls: true,

                // Mouse click on image should close the gallery,
                // only when image is smaller than size of the viewport
                clickToCloseNonZoomable: false,

                // Maximum zoom level when performing spread (zoom) gesture. 2 means that image can be zoomed 2x from original size. Try to avoid huge values here, as too big image may cause memory issues on mobile (especially on iOS).
                maxSpreadZoom: 3,

                // Element classes click on which should close the PhotoSwipe.
                // In HTML markup, class should always start with "pswp__", e.g.: "pswp__item", "pswp__caption".
                //
                // "pswp__ui--over-close" class will be added to root element of UI when mouse is over one of these elements
                // By default it's used to highlight the close button.
                closeElClasses: ['item', 'caption', 'zoom-wrap', 'ui', 'top-bar'],

                // Separator for "1 of X" counter
                indexIndicatorSep: ' / '

            }, options);

            if (items.length) {
                this.photoswipe = new PhotoSwipe(this.$el, PhotoSwipeDefaultUI, items, opts);
                this.photoswipe.init();

                this.photoswipe.listen('beforeChange', this.beforeChange);
                this.photoswipe.listen('afterChange', this.afterChange);

                this.photoswipe.listen('close', () => {
                    this.$emit('close');
                });

                // TODO: link to artwork from the title bar
                // this.photoswipe.framework.bind(this.photoswipe.scrollWrap, 'pswpTap', (event) => {
                //     console.log("tapped", event.detail.target);
                //     event.preventDefault();
                //     event.stopPropagation();
                //     event.cancelBubble = true;
                //     return false;
                // });
            }
        },

        close: function () {
            try {
                // this errors out sometimes during specs due to race condition
                this.photoswipe && this.photoswipe.close();
            }
            catch (error) {}
        },

        /**
         * Paginate, beforeChange.
         * Sometimes there would be more artworks in the whole set, but the slideshow was called
         * with just a subset. The paginator should be called here to update the page.
         * Param `direction` is 1 to next and -1 to prev.
         *
         * https://photoswipe.com/documentation/api.html
         */
        beforeChange: function (direction) {
            const currIndex = this.photoswipe.getCurrentIndex();
            if (direction === -1 && currIndex === 0) {
                // first item, going back
                this.$emit('prev-page');
                return false;
            }

            const numItems = this.photoswipe.options.getNumItemsFn();
            if (direction === 1 && currIndex === (numItems - 1)) {
                // last item, going forward
                this.$emit('next-page');
                return false;
            }
        }

        // afterChange: function (direction) {
        //     const currIndex = this.photoswipe.getCurrentIndex();
        // }
    }
};
</script>

<style lang="scss">
/* stylelint-disable selector-class-pattern */
.pswp {
    z-index: 15000 !important; // must exceed navigation
    .pswp__caption {
        top: 0;
        bottom: unset;
        z-index: 2000;
        font-family: 'Sabon MT W01 Regular', serif;
        user-select: none;
        .pswp__caption__center {
            max-width: calc(100% - 88px);
            font-size: 1.25rem;
            color: white;
            text-align: center;
        }
    }
    .pswp__top-bar {
        z-index: 2001;
    }
}
</style>
